import { ActionIcon, Button, Group, Tooltip } from "@mantine/core";
import {
	IconDashboard,
	IconEdit,
	IconLayoutDashboard,
	IconLogout,
} from "@tabler/icons-react";

const PENDING_HINT = "Menunggu verifikasi admin";

export interface ProfileHeaderActionsProps {
	isAdmin: boolean;
	isVerified: boolean;
	onDashboard: () => void;
	onAdminPanel: () => void;
	onEdit: () => void;
	onLogout: () => void;
}

/** Deretan aksi di kepala halaman profil: admin panel, dashboard panel, edit, keluar. */
export function ProfileHeaderActions({
	isAdmin,
	isVerified,
	onDashboard,
	onAdminPanel,
	onEdit,
	onLogout,
}: ProfileHeaderActionsProps) {
	return (
		<>
			<Group gap="xs" wrap="nowrap" hiddenFrom="sm" style={{ flexShrink: 0 }}>
				{isAdmin && (
					<Tooltip label="Admin Panel">
						<ActionIcon
							variant="light"
							color="orange"
							size="lg"
							aria-label="Admin Panel"
							onClick={onAdminPanel}
						>
							<IconDashboard size={16} />
						</ActionIcon>
					</Tooltip>
				)}
				<Tooltip label={isVerified ? "Dashboard Panel" : PENDING_HINT}>
					<ActionIcon
						variant="light"
						color="gray"
						size="lg"
						aria-label="Dashboard Panel"
						disabled={!isVerified}
						onClick={onDashboard}
					>
						<IconLayoutDashboard size={16} />
					</ActionIcon>
				</Tooltip>
				<Tooltip label="Edit Profil">
					<ActionIcon
						variant="light"
						color="blue"
						size="lg"
						aria-label="Edit Profil"
						onClick={onEdit}
					>
						<IconEdit size={16} />
					</ActionIcon>
				</Tooltip>
				<Tooltip label="Keluar">
					<ActionIcon
						variant="outline"
						color="red"
						size="lg"
						aria-label="Keluar"
						onClick={onLogout}
					>
						<IconLogout size={16} />
					</ActionIcon>
				</Tooltip>
			</Group>

			<Group visibleFrom="sm" style={{ flexShrink: 0 }}>
				{isAdmin && (
					<Button
						variant="light"
						color="orange"
						leftSection={<IconDashboard size={18} />}
						onClick={onAdminPanel}
					>
						Admin Panel
					</Button>
				)}
				<Tooltip label={PENDING_HINT} disabled={isVerified}>
					<Button
						variant="light"
						color="gray"
						leftSection={<IconLayoutDashboard size={18} />}
						disabled={!isVerified}
						onClick={onDashboard}
					>
						Dashboard Panel
					</Button>
				</Tooltip>
				<Button
					variant="light"
					color="blue"
					leftSection={<IconEdit size={18} />}
					onClick={onEdit}
				>
					Edit Profil
				</Button>
				<Button
					variant="outline"
					color="red"
					leftSection={<IconLogout size={18} />}
					onClick={onLogout}
				>
					Keluar
				</Button>
			</Group>
		</>
	);
}
